import * as React from "react";
import styled, { css } from "styled-components";
import * as moment from "moment-timezone";

import {
  BasicModal,
  BasicModalProps
} from "src/library/components/Modal/BasicModal";
import { ISupportTicketTimeTaken } from "src/modules/support/api/support.api";
import { Text } from "src/library/components/Text";
import { minutesToHHMM } from "src/library/utils/time-helpers/time-helpers";

export interface SupportTicketTimeTakenListModalProps extends Pick<BasicModalProps, "onDismiss" | "open"> {
  timeTaken: ISupportTicketTimeTaken[];
}

/**
 * A simple list of time taken showing user name, date and time recorded, displayed in a modal
 */
export const SupportTicketTimeTakenListModal: React.FC<SupportTicketTimeTakenListModalProps> = ({
  onDismiss, open, timeTaken
}) => {
  return (
    <StyledBasicModal
      title="List of time logged"
      open={open}
      onDismiss={onDismiss}
    >
      {timeTaken.length === 0 ? (
        <Text>
          No time taken found.
        </Text>
      ) : (
        timeTaken.map((tt, iteration) => (
          <div
            key={tt.id}
            className={`time-taken-row ${iteration === timeTaken.length - 1 ? "" : "border"}`}
          >
            <div className="row-field">
              <Text>
                {tt.user ? `${tt.user.firstName} ${tt.user.lastName}` : ""}
              </Text>
            </div>

            <div className="row-field">
              <Text>
                {moment.utc(tt.createdAt).format("YYYY/MM/DD")}
              </Text>
            </div>

            <div className="row-field">
              <Text>
                {minutesToHHMM(tt.timeTaken)}
              </Text>
            </div>
          </div>
        ))
      )}
    </StyledBasicModal>
  );
};

const StyledBasicModal = styled(BasicModal)`
  ${({ theme }) => css`
    .time-taken-row {
      display: flex;
    }

    .row-field {
      padding: ${theme.spacing.padding.sm};
      flex: 1;
    }

    .border {
      border-bottom: 1px solid ${theme.colors.lightGrey};
    }
  `}
`;
